import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PassFoodCardRequest } from '@libs/shared/api';
import { PassFoodCardDialogComponent } from '@libs/shared/ui/dialogs/pass-food-card-dialog/pass-food-card-dialog.component';

@Injectable()
export class PassFoodCardDialogService {
  readonly matDialog = inject(MatDialog);

  open(): MatDialogRef<PassFoodCardDialogComponent, PassFoodCardRequest> {
    return this.matDialog.open(PassFoodCardDialogComponent, {
      autoFocus: true,
      disableClose: false,
    });
  }
}
